export default {
  'menu.welcome': 'Chào mừng',
  'menu.home': 'Trang chủ',
  'menu.login': 'Đăng nhập',
  'menu.register': 'Đăng ký',
  'menu.register-result': 'Kết quả đăng ký',
  'menu.dashboard': 'Trang tổng quan',
  'menu.dashboard.analysis': 'Phân tích',
  'menu.dashboard.monitor': 'Giám sát',
  'menu.dashboard.workplace': 'Nơi làm việc',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.profile': 'Hồ sơ',
  'menu.profile.basic': 'Thông tin cơ bản',
  'menu.profile.advanced': 'Thông tin nâng cao',
  'menu.result': 'Kết quả',
  'menu.result.success': 'Thành công',
  'menu.result.fail': 'Thất bại',
  'menu.exception': 'Lỗi hệ thống',
  'menu.exception.not-permission': 'Không có quyền truy cập',
  'menu.exception.not-find': 'Không tìm thấy trang',
  'menu.exception.server-error': 'Lỗi máy chủ',
  'menu.exception.trigger': 'Kích hoạt lỗi',
  'menu.account': 'Tài khoản',
  'menu.account.center': 'Thông tin cá nhân',
  'menu.account.settings': 'Cài đặt',
  'menu.account.trigger': 'Kích hoạt lỗi',
  'menu.account.logout': 'Đăng xuất',
  'menu.editor': 'Trình chỉnh sửa',
  'menu.editor.flow': 'Chỉnh sửa Flow',
  'menu.editor.mind': 'Chỉnh sửa Mind',
  'menu.editor.koni': 'Chỉnh sửa Koni',

  'menu.admin': 'Quản trị',
  'menu.admin.checklist': 'Danh sách kiểm tra',
  'menu.admin.sourceTransaction': 'Giao dịch nguồn',
  
  // ==================== Nhóm Menu ====================
  
  // Nhóm Nghiệp vụ
  'menu.business': 'Nghiệp vụ',
  'menu.business.sourceTransaction': 'Giao dịch nguồn',
  'menu.business.inspectionRequestCoordinator': 'Yêu cầu kiểm tra',
  'menu.business.inspectionRequestInspector': 'Danh sách kiểm tra',
  'menu.business.inspectionResult': 'Kết quả kiểm tra',
  'menu.business.inspectionInline': 'Kiểm tra Inline',
  
  // Nhóm Cài đặt
  'menu.setting': 'Cài đặt',
  'menu.setting.checklist': 'Danh sách kiểm tra',
  'menu.setting.defectList': 'Danh sách lỗi',
  'menu.setting.qcDefinition': 'Tiêu chuẩn chất lượng',
  'menu.setting.mapping': 'Liên kết',
  
  // Nhóm Danh mục
  'menu.list': 'Danh mục',
  'menu.list.defectGroup': 'Nhóm lỗi',
  'menu.list.defectAction': 'Hành động khắc phục',
  'menu.list.defectReason': 'Nguyên nhân lỗi',
  'menu.list.defect': 'Lỗi',
  'menu.list.defectConversion': 'Quy đổi lỗi',
  
  // Nhóm Báo cáo
  'menu.report': 'Báo cáo',
  'menu.report.reportTemplate': 'Mẫu báo cáo',
  'menu.report.reportDocs': 'Tài liệu báo cáo',

  // ==================== Trang Tài liệu báo cáo ====================
  'pages.reportDocs.templateDesign.title': 'Hướng dẫn thiết kế mẫu báo cáo',
  'pages.reportDocs.templateDesign.description':
    'Hướng dẫn chi tiết cách thiết kế mẫu báo cáo và sử dụng placeholders cho báo cáo Kết quả kiểm tra.',
  'pages.reportDocs.view': 'Xem',
  'pages.reportDocs.hide': 'Ẩn',
  'pages.reportDocs.placeholder': 'Chọn một tài liệu từ danh sách để xem nội dung.',

  // ==================== Trang Kết quả kiểm tra ====================
  'pages.inspectionResult.sourceTransactionCode': 'Giao dịch nguồn',
  
  // ==================== Mục menu cũ (Giữ để tương thích ngược) ====================
  'menu.sourceTransaction': 'Giao dịch nguồn',
  'menu.inspectionRequestCoordinator': 'Yêu cầu kiểm tra',
  'menu.inspectionRequestInspector': 'Danh sách kiểm tra',
  'menu.inspectionResult': 'Kết quả kiểm tra',
  'menu.inspectionInline': 'Kiểm tra Inline',
  'menu.checklist': 'Danh sách kiểm tra',
  'menu.defectList': 'Danh sách lỗi',
  'menu.qcDefinition': 'Tiêu chuẩn chất lượng', 
  'menu.mapping': 'Liên kết',
  'menu.defectGroup': 'Nhóm lỗi',
  'menu.defectAction': 'Biện pháp',
  'menu.defectReason': 'Nguyên nhân lỗi',
  'menu.defect': 'Lỗi',
  'menu.defectConversion': 'Quy đổi lỗi',
  'menu.reportTemplate': 'Mẫu báo cáo',
  'menu.reportDocs': 'Tài liệu báo cáo',
};
